module.exports = __webpack_public_path__ + "media/components/home/users-are-saying/img/facebook-icon-229dd0b25b326431fb066b3ebf649cc5.svg";